// @flow
import { createSelector } from 'reselect';
import { clientIdSelector } from './sessionSelector';

export const clientSettingsSelector = createSelector(
    [
        clientIdSelector,
        (state: Object) => {
            return state.clientSettings.clientSettingsMap;
        }
    ],
    (clientId, clientSettingsMap) => {
        return clientSettingsMap.get(clientId);
    }
);

const clientSettingsSelectorByClientId = (state: Object, clientId: string) => {
    return state.clientSettings.clientSettingsMap.get(clientId);
};

export { clientSettingsSelectorByClientId };
export default clientSettingsSelector;
